import React from "react";
import styled from "styled-components";

import { LogoGrey } from "config/images";

const Wrapper = styled.div`
  padding: 8vw 0 4vw 0;
  img {
    width: 80vw;
  }
`;

export default function Logo() {
  return (
    <Wrapper>
      <img alt="la-prairie-logo" src={LogoGrey} />
    </Wrapper>
  );
}
